import { isEmpty } from 'lodash-es';
import { filterXSS } from 'xss';

/*
  checkEmpty(null)        // => true
  checkEmpty(undefined)   // => true
  checkEmpty(NaN)         // => true
  checkEmpty({})          // => true
  checkEmpty([])          // => true
  checkEmpty('')          // => true

  checkEmpty(true)        // => false
  checkEmpty(false)       // => false
  checkEmpty(1)           // => false
  checkEmpty(0)           // => false
  checkEmpty(new Date())  // => false

  checkEmpty(() => {})    // => true
  NOTE: checkEmpty(function) will be true since there is no value.
  NOTE: The strings '{}' and '[]' also results in true (empty)
*/
export const checkEmpty = (value: any) => {
  if (typeof value === 'number' && !Number.isNaN(value)) {
    return false;
  }

  if (typeof value === 'boolean') {
    return false;
  }

  if (Object.prototype.toString.call(value) === '[object Date]') {
    return false;
  }

  if (value === '{}' || value === '[]') {
    return true;
  }

  return isEmpty(value);
};

// NOTE: Order matters here, since ampersands need to be escaped before escaping other characters
const charToReplace = [
  ['&', '&amp;'],
  ['<', '&lt;'],
  ['>', '&gt;'],
  ['"', '&quot;'],
  [`'`, '&#x27;'],
  ['/', '&#x2F;'],
];
export const sanitize = (value: string) => {
  if (!value) {
    return '';
  }

  let newVal = value;
  for (const entry of charToReplace) {
    newVal = newVal.replace(new RegExp(entry[0], 'g'), entry[1]);
  }

  return newVal;
};

// Note: For options, check http://jsxss.com/en/options.html
export const sanitizeXss = (html: string, options?: XSS.IFilterXSSOptions) =>
  filterXSS(html, options);
